import React from 'react';

const CSS = require('./InputGroup.less');

function InputGroup({ children }) {
  return (
    <div className={CSS.inputGroup}>
      {children}
    </div>
  );
}

export default InputGroup;
